module.exports = __webpack_public_path__ + "static/media/91tE2IOWncL._AC_SL1500_.c82005b7.jpg";